import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getCompaniesListApi } from '@src/api';
import { CompanyListParams } from './company';

const getCompanyList = createAsyncThunk(
  'users/getCompanyList',
  async (
    {
      page = 1,
      limit = 20,
      sortBy = [''],
      searchBy = ['name'],
      search,
    }: // filter = '',
    CompanyListParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await getCompaniesListApi({
        page,
        limit,
        sortBy,
        searchBy,
        search,
      });

      return response.result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export default getCompanyList;
